import Vue from 'vue'
import Mutations from '../data/mutations'
export default {
  namespaced: true,
  state: {
    sites: [],
    listView: false,
    projects: [],
    sortBy: '',
    filterBy: '',
    project: '',
    loadingSites: false,
    loadingProjects: false,
    showDetails: false,
    selectedRecordType: 'Active'
  },
  mutations: Mutations,
  actions: {
    resetForm(context) {
      context.commit('modifyContractor', '')
      context.commit('modifySite', '')
      context.commit('modifyVehicle', '')
      context.commit('modifySite', '')
      context.commit('resetTrips')
    }
  },
  getters: {
    getSites: state => state.sites
  }
}
